import { defaultApi } from '@/plugins/api/defaultApi'
import moment from 'moment'

const st = {
  name: 'bankMaintenance',
  namespaced: true,
  getters: {
    /**
     * 상시 점검 시작/종료 moment 객체 반환
     * 현재 시간 기준으로 실제 점검 시간대 반환
     */
    defaultMaintenanceTime: () => {
      // 상시 점검 시간 상수 (전날 밤 11시 ~ 다음날 새벽 1시 30분)
      const PREVIOUS_DAY_START = { hour: 23, minute: 0 } // 전날 밤 11시
      const NEXT_DAY_END = { hour: 1, minute: 30 } // 다음날 새벽 1시 30분

      const now = moment()
      const currentMinutes = now.hour() * 60 + now.minute()
      const endMinutes = NEXT_DAY_END.hour * 60 + NEXT_DAY_END.minute

      // 시작 날짜 결정: 현재가 00:00~01:30이면 어제, 아니면 오늘
      const startDay = currentMinutes < endMinutes ? moment().subtract(1, 'day') : moment()

      return {
        start: startDay
          .clone()
          .hour(PREVIOUS_DAY_START.hour)
          .minute(PREVIOUS_DAY_START.minute)
          .second(0),
        end: startDay
          .clone()
          .add(1, 'day')
          .hour(NEXT_DAY_END.hour)
          .minute(NEXT_DAY_END.minute)
          .second(0),
      }
    },

    /**
     * 현재 상시 점검 시간인지 체크
     */
    isDefaultMaintenanceTime: (_, getters) => {
      const { start, end } = getters.defaultMaintenanceTime
      return moment().isBetween(start, end, null, '[)') // inclusive start, exclusive end
    },
  },
  actions: {
    /**
     * 특정 은행의 특별 점검 여부 확인
     * (상시 점검 시간 제외)
     */
    async checkBankMaintenance({}, bankCode) {
      const { data } = await defaultApi.getBankMaintenances({
        bank: bankCode,
        ongoing: true,
      })
      return data.results.length > 0
    },
  },
}

export default st
